import React from "react";
import EventsListView from "./EventsListView";

export default function EventsTab() {
  return (
    <div>
      <EventsListView />
    </div>
  );
}
